<template>
  <div class="accordion-item">
    <div class="accordion-title" :class="{'active' : active}" @click="toggle">
      <slot name="title"></slot>
      <span v-if="hasByline" class="accordion-byline"><slot name="byline"></slot></span>
    </div>
    <div class="accordion-content" ref="content" :class="{'active' : active}" :style="setHeight">
      <div class="accordion-inner">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>


<script>
  import { EventBus } from '/event-bus.js';

  export default {
    props: {
      groupUid: { // Provide to expand / collapse all. 
        type: Number, // Date.now() + Math.random()
        default: 0
      },
      singleMode: { // Provide if only one drawer to be open at a time. 
        type: Boolean,
        default: false
      },
      open: {
        type: Boolean,
        default: false
      }
    },
    data(){
      return {
        active: false,
        scrollHeight: null,
        width: null,
        interval: null,
        uid: Date.now() + Math.random(),
      }
    },
    computed: {
      setHeight(){
        if(this.active && this.scrollHeight) {
          return { height : this.scrollHeight + 'px'}
        }
      },
      hasByline(){
        return this.$slots.byline
      }
    },
    methods: {
      toggle(viaAll) {
        if(this.$refs.content !== undefined) {
          this.active = !this.active
          this.scrollHeight = this.$refs.content.scrollHeight
          
          if(this.singleMode && viaAll !== true && this.groupUid && this.active) {
            EventBus.$emit('accordionChange', {uid: this.uid, groupUid: this.groupUid});
          }
        }
      },
      close() {
        if(window.innerWidth !== this.width) {
          this.width = window.innerWidth
          this.active = false
        }
      }
    },
    created() {
      this.width = window.innerWidth
      window.addEventListener('resize',this.close);

      if(this.singleMode && this.groupUid) {
        EventBus.$on('accordionChange', (emit) => {
          if(emit.groupUid === this.groupUid && this.uid !== emit.uid) {
            this.active = false
          }
        });
      }

      if(this.groupUid) {
        EventBus.$on('toggleAll', (emit) => {
          // console.log('expand all')
          // console.log(emit.status)
          if(this.groupUid === emit.uid) {
            if(!this.active && emit.status) {
              this.toggle(true)
            } else if(this.active && !emit.status) {
              this.toggle(true)
            }
          }
        });
      }

     this.interval = setInterval(() => {
        if (this.$refs.content.scrollHeight && this.open) {
          this.toggle()
          clearInterval(this.interval)
        }
      }, 50)
    },
    destroyed() {
      clearInterval(this.interval)
      window.removeEventListener('resize',this.close);
    }
  }
</script>